import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SummaryDataModel} from "./models/summary-data-model";

@Component({
  selector: 'ebw-monorepo-summary-component',
  templateUrl: './summary-component.component.html',
  styleUrls: ['./summary-component.component.scss']
})
export class SummaryComponentComponent implements OnInit {
  @Input() data: SummaryDataModel<any,any>[];
  @Output() applyFilterHandler: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {}

  applayFilter(headerElement: any, contentElement: any) {
    // rimosso il controllo precedente headerElement !== 0 per avere un comportamento omogeneo per tutti i filtri
    if (headerElement)
      this.applyFilterHandler.emit(contentElement);
  }
}
